module.exports = __webpack_public_path__ + "img/icon-54.7cb19189.svg";